export function getLegacySafeAreaInsets(): {
  top: number;
  bottom: number;
  left: number;
  right: number;
} {
  const el = document.createElement('div');

  el.style.position = 'absolute';
  el.style.top = '0';
  el.style.left = '0';
  el.style.width = '1px';
  el.style.height = '1px';
  el.style.pointerEvents = 'none';
  el.style.opacity = '0';
  el.style.zIndex = '-1';

  // Set padding to safe area insets
  el.style.paddingTop = 'env(safe-area-inset-top)';
  el.style.paddingRight = 'env(safe-area-inset-right)';
  el.style.paddingBottom = 'env(safe-area-inset-bottom)';
  el.style.paddingLeft = 'env(safe-area-inset-left)';

  document.body.appendChild(el);

  const computed = window.getComputedStyle(el);

  const insets = {
    top: parseFloat(computed.paddingTop) || 0,
    right: parseFloat(computed.paddingRight) || 0,
    bottom: parseFloat(computed.paddingBottom) || 0,
    left: parseFloat(computed.paddingLeft) || 0,
  };

  document.body.removeChild(el);

  return insets;
}
